import firebase from "firebase"
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDHKH4tRNodPR-81bplsl01Tzfuha-yzMQ",
    authDomain: "react-auth-6f696.firebaseapp.com",
    projectId: "react-auth-6f696",
    storageBucket: "react-auth-6f696.appspot.com",
    messagingSenderId: "523664066703",
    appId: "1:523664066703:web:0fa0f5555a36b3128008fa"
  };
  
  // Initialize Firebase
  const fire =firebase.initializeApp(firebaseConfig);

  export default fire;